import { Box } from '@mui/material';
import { Dialog, Typography, type DialogAction, type DialogCancelAction } from '@sm-dashboard/ui-components';
import React from 'react';

const DynamicDialog = ({
  open,
  title,
  subtitle,
  description,
  handleNotOkClose,
  handleOkClose,
  primaryAction,
  cancelAction,
  secondaryActions,
  children,
  loading,
  allowOverflow
}: {
  open: boolean;
  title: string;
  subtitle?: string;
  description?: string;
  handleOkClose: () => void;
  handleNotOkClose: () => void;
  /** Overrides the default "אישור" button (calls `handleOkClose`). */
  primaryAction?: DialogAction;
  /** Overrides the default "ביטול" button (calls `handleNotOkClose`); `false` hides it. */
  cancelAction?: DialogCancelAction | false;
  secondaryActions?: DialogAction[];
  children?: React.ReactNode;
  loading?: boolean;
  allowOverflow?: boolean;
}) => {
  return (
    <Dialog
      open={open}
      aria-describedby="alert-dialog-dynamic"
      onClose={handleNotOkClose}
      allowOverflow={allowOverflow}
      title={title}
      cancelAction={cancelAction === false ? undefined : cancelAction ?? true}
      secondaryActions={secondaryActions}
      primaryAction={primaryAction ?? { label: 'אישור', onClick: handleOkClose, loading }}
    >
      {subtitle && (
        <Box id="alert-dialog-dynamic">
          <Typography variant="body" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
      )}
      {description && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" color="text.secondary">
            {description}
          </Typography>
        </Box>
      )}
      {children}
    </Dialog>
  );
};

export default DynamicDialog;
